import { Direction_Enum } from '@weave/schema-gen-ts/dist/schemas/fax/shared/v1/enums.pb';
import { Bool_Enum } from '@weave/schema-gen-ts/dist/shared/null/types.pb';
import { FaxTypes, FaxV1 } from '@frontend/api-fax';

type Props = {
  locationId: string;
  locationIds: string[];
  type: FaxTypes.InboxType;
  isViewed?: Bool_Enum;
  isDelivered?: Bool_Enum;
  direction?: Direction_Enum;
  tags?: string[];
  startAt?: string;
  endAt?: string;
  locationPhones?: string[];
};

export const useListFaxes = ({
  locationId,
  locationIds,
  type,
  isViewed,
  isDelivered,
  direction,
  tags,
  startAt,
  endAt,
  locationPhones,
}: Props) => {
  const paginatedListFaxesInfiniteQuery = FaxV1.Queries.useListFaxesInfiniteQuery({
    request: {
      locationId,
      locationIds,
      isViewed,
      isDelivered,
      direction,
      tags,
      locationPhones,
      startAt,
      endAt,
    },
    options: {
      enabled: type === FaxTypes.InboxType.INBOX,
    },
  });

  const paginatedListBlockedFaxesInfiniteQuery = FaxV1.Queries.useListBlockedFaxesQuery({
    request: {
      locationId,
      locationIds,
    },
    options: {
      enabled: type === FaxTypes.InboxType.BLOCKED,
    },
  });

  const paginatedListArchivedFaxesInfiniteQuery = FaxV1.Queries.useListArchivedFaxesQuery({
    request: {
      locationId,
      locationIds,
    },
    options: {
      enabled: type === FaxTypes.InboxType.ARCHIVED,
    },
  });

  const paginatedQuery =
    type === FaxTypes.InboxType.ARCHIVED
      ? paginatedListArchivedFaxesInfiniteQuery
      : type === FaxTypes.InboxType.BLOCKED
      ? paginatedListBlockedFaxesInfiniteQuery
      : paginatedListFaxesInfiniteQuery;

  return {
    paginatedQuery,
  };
};
